import React from 'react';
import { sections } from './LegalPage';
import '../../styles/chat.css';
import '../../styles/auth.css';

export default function LegalModal({ type, onClose }) {
  const isPrivacy = type === 'privacy';
  const list = sections[isPrivacy ? 'privacy' : 'terms'];

  return (
    <div className="modal-overlay" onClick={(e) => { e.stopPropagation(); onClose(); }}>
      <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
        <div className="legal-modal-header">
          <h3>{isPrivacy ? 'Политика конфиденциальности' : 'Правила пользования'}</h3>
          <button className="modal-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="legal-modal-body">
          {list.map((s) => (
            <div key={s.title} className="legal-section">
              <h2>{s.title}</h2>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}